import React, { useContext, useRef, useState } from "react";
import "./Contact.css";
import emailjs from "@emailjs/browser";
import { themeContext } from "../../Context";
import Loader from "../Loader/Loader";

const Contact = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const form = useRef();
  const [done, setDone] = useState(false);
  const [loader, setLoader] = useState(false);
  const sendEmail = (e) => {
    e.preventDefault();
    setLoader(true);
    emailjs
      .sendForm(
        "service_j4b13ha",
        "template_lcl1h3s",
        form.current,
        "u9oXmjZOuay6XPx7k"
      )
      .then(
        (result) => {
          setLoader(false);
          setDone(true);
          form.current.reset();
        },
        (error) => {
          setLoader(false);
        }
      );
  };

  const handleOnChange = () => {
    setDone(false);
  };

  return (
    <div className="contact-form" id="contact">
      {/* left side copy and paste from work section */}
      <div className="w-left">
        <div className="awesome">
          {/* darkMode */}
          <span style={{ color: darkMode ? "white" : "" }}>Get in Touch</span>
          <span>Contact me</span>
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>
      </div>
      {/* right side form */}
      <div className="c-right">
        <form ref={form} onChange={handleOnChange} onSubmit={sendEmail}>
          <input
            type="text"
            name="user_name"
            className="user"
            placeholder="Name"
            required
          />
          <input
            type="email"
            name="user_email"
            className="user"
            placeholder="Email"
            required
          />
          <textarea
            name="message"
            className="user"
            placeholder="Message"
            required
          />
          <button className="button" type="submit">
            Send
          </button>
          <span className="success">
            {done && "Thanks for reaching out to me"}
          </span>
          <div
            className="blur c-blur1"
            style={{ background: "var(--purple)" }}
          ></div>
        </form>
      </div>
      {loader === true ? <Loader /> : <></>}
    </div>
  );
};

export default Contact;
